<section class="qvs-login-mobile-download">
  <hr class="qvs-login-mobile-download__divider" />
  <h1 class="qvs-login-mobile-download__title">{{ 'ebanking.login.MOBILE_APP_TITLE' | translate }}</h1>

  <ion-segment class="qvs-login-mobile-download__segment" [(ngModel)]="selectedSegment" mode="ios">
    <ion-segment-button [value]="segment.IOS">
      <ion-label>{{ 'ebanking.login.IOS' | translate }}</ion-label>
    </ion-segment-button>
    <ion-segment-button [value]="segment.ANDROID">
      <ion-label>{{ 'ebanking.login.ANDROID' | translate }}</ion-label>
    </ion-segment-button>
  </ion-segment>

  <div [ngSwitch]="selectedSegment" class="qvs-login-mobile-download__grid">
    <ng-container *ngSwitchCase="segment.IOS">
      <div class="qvs-login-mobile-download__app-info">
        <qvs-svg-icon class="qvs-login-mobile-download__app-icon--access" [src]="assets.icons.access"></qvs-svg-icon>
        <span>{{ 'ebanking.login.ACCESS_APP' | translate }}</span>
      </div>

      <div class="qvs-login-mobile-download__app-info">
        <qvs-svg-icon class="qvs-login-mobile-download__app-icon--banking" [src]="assets.icons.banking"></qvs-svg-icon>
        <span>{{ 'ebanking.login.BANKING_APP' | translate }}</span>
      </div>

      <div class="qvs-login-mobile-download__app-download">
        <img
          class="qvs-login-mobile-download__qr-code"
          [src]="assets.qrCodes.ios.access"
          [alt]="'ebanking.login.QR_CODE_ALT_IOS_ACCESS' | translate"
        />
        <a
          [href]="assets.storeLinks.ios.access"
          target="_blank"
          rel="noopener noreferrer"
          [attr.aria-label]="'ebanking.login.DOWNLOAD_ACCESS_IOS_APP_STORE' | translate"
        >
          <qvs-svg-icon class="qvs-login-mobile-download__store-logo" [src]="assets.storeLogos.ios"></qvs-svg-icon>
        </a>
      </div>

      <div class="qvs-login-mobile-download__app-download">
        <img
          class="qvs-login-mobile-download__qr-code"
          [src]="assets.qrCodes.ios.banking"
          [alt]="'ebanking.login.QR_CODE_ALT_IOS_BANKING' | translate"
        />
        <a
          [href]="assets.storeLinks.ios.banking"
          target="_blank"
          rel="noopener noreferrer"
          [attr.aria-label]="'ebanking.login.DOWNLOAD_BANKING_IOS_APP_STORE' | translate"
        >
          <qvs-svg-icon class="qvs-login-mobile-download__store-logo" [src]="assets.storeLogos.ios"></qvs-svg-icon>
        </a>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="segment.ANDROID">
      <div class="qvs-login-mobile-download__app-info">
        <qvs-svg-icon class="qvs-login-mobile-download__app-icon--access" [src]="assets.icons.access"></qvs-svg-icon>
        <span>{{ 'ebanking.login.ACCESS_APP' | translate }}</span>
      </div>

      <div class="qvs-login-mobile-download__app-info">
        <qvs-svg-icon class="qvs-login-mobile-download__app-icon--banking" [src]="assets.icons.banking"></qvs-svg-icon>
        <span>{{ 'ebanking.login.BANKING_APP' | translate }}</span>
      </div>

      <div class="qvs-login-mobile-download__app-download">
        <img
          class="qvs-login-mobile-download__qr-code"
          [src]="assets.qrCodes.android.access"
          [alt]="'ebanking.login.QR_CODE_ALT_ANDROID_ACCESS' | translate"
        />
        <a
          [href]="assets.storeLinks.android.access"
          target="_blank"
          rel="noopener noreferrer"
          [attr.aria-label]="'ebanking.login.DOWNLOAD_ACCESS_ANDROID_APP_STORE' | translate"
        >
          <qvs-svg-icon class="qvs-login-mobile-download__store-logo" [src]="assets.storeLogos.android"></qvs-svg-icon>
        </a>
      </div>

      <div class="qvs-login-mobile-download__app-download">
        <img
          class="qvs-login-mobile-download__qr-code"
          [src]="assets.qrCodes.android.banking"
          [alt]="'ebanking.login.QR_CODE_ALT_ANDROID_BANKING' | translate"
        />
        <a
          [href]="assets.storeLinks.android.banking"
          target="_blank"
          rel="noopener noreferrer"
          [attr.aria-label]="'ebanking.login.DOWNLOAD_BANKING_ANDROID_APP_STORE' | translate"
        >
          <qvs-svg-icon class="qvs-login-mobile-download__store-logo" [src]="assets.storeLogos.android"></qvs-svg-icon>
        </a>
      </div>
    </ng-container>
  </div>
</section>
